<template>
  <div class="container client">
    <div style="color:black">
      问题与建议
    </div>
    <el-card style="margin-top: 20px;">
      <div style="display:flex; justify-content: space-between;">
        <el-form class="search-wrap"
                 ref="searchForm"
                 :inline="true"
                 :model="query"
                 size="small"
                 label-position="left">
          <el-form-item label="类型">
            <el-select v-model="query.question_types"
                       placeholder="请选择"
                       clearable
                       style="width:200px;"
                       @change="getList(true)">
              <el-option v-for="item in  qustionType"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="平台id"
                      prop="client_id">
          <el-select v-model="query.client_id"
                     placeholder="请选择客户端"
                     clearable
                     @change="fetchServiceList(true)"
                     style="width: 100%;">
            <el-option v-for="item in clients"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item> -->
        </el-form>
      </div>
    </el-card>
    <el-card style="margin-top: 20px">
      <div class="table-header">
        <h3 class="title">用户列表</h3>
        <el-form :inline="true"
                 label-width="70px"
                 size="small">
          <el-form-item>
            <el-radio-group v-model="progress_Status"
                            @change="getList(true)">
              <el-radio-button v-for="(item, index) in  progressStatus"
                               :key="index"
                               :label="item.value">
                {{ item.label }}
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>

      <el-table :data="results"
                :header-cell-style="{
          textAlign: 'center',
        }"
                @selection-change="handleSelectionChange"
                border>
        <el-table-column type="selection"
                         width="50"
                         fixed="left"
                         align="center"></el-table-column>
        <el-table-column type="index"
                         width="70"
                         label="序号"
                         align="center">
        </el-table-column>

        <el-table-column align="center"
                         label="类型"
                         width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.question_type==1">问题与反馈</div>
            <div v-if="scope.row.question_type==2">功能建议</div>
          </template>
        </el-table-column>
        <el-table-column align="left"
                         label="内容描述"
                         prop="question_content"
                         show-overflow-tooltip>

        </el-table-column>
        <el-table-column align="left"
                         label="关联图片"
                         width="200"
                         prop="question_img_urls"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.question_img_urls !=''"
                 class="imgBox">
              <div v-for="(item,index) in scope.row.question_img_urls.split(',')"
                   :key="index"> <el-image style="width: 35px; height: 35px;marginRight:10px"
                          fit="cover"
                          :src="item"
                          :preview-src-list="[item]">
                </el-image></div>

            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>

        <el-table-column align="left"
                         label="处理进度"
                         width="90"
                         prop="handle_progress_status"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag v-if="scope.row.handle_progress_status==0"
                    type="warning">待处理</el-tag>
            <el-tag v-if="scope.row.handle_progress_status==1">已查看</el-tag>
            <el-tag v-if="scope.row.handle_progress_status==2">已处理</el-tag>
            <el-tag v-if="scope.row.handle_progress_status==3"
                    type="info">已采纳</el-tag>
          </template>
        </el-table-column>

        <el-table-column align="center"
                         label="提交人"
                         width="170"
                         prop="handle_progress_status"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.creator_obj">
              <span>{{scope.row.creator_obj.nickname}}</span> /<span v-if="scope.row.creator_obj.mobile">{{scope.row.creator_obj.mobile}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center"
                         label="提交时间"
                         width="150">
          <template slot-scope="scope">
            {{scope.row.create_time?$moment(scope.row.create_time).format("YYYY-MM-DD HH:mm"):""}}
          </template>
        </el-table-column>
        <el-table-column align="center"
                         label="更新时间"
                         width="150">
          <template slot-scope="scope">
            {{scope.row.update_time?$moment(scope.row.update_time).format("YYYY-MM-DD HH:mm"):""}}
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="90"
                         align="center">
          <template slot-scope="scope">
            <div class="link-wrap">
              <el-link type="primary"
                       :underline="false"
                       @click="handleToDetail(scope.row)">查看详情</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div style="display:flex; justify-content: space-between; marginTop:16px">
        <div class="footer">
          <div class="left">
            <span>已选 {{chooseList.length}} 条</span>
            <span class="xian"></span>
            <span style="marginRight:16px">批量</span>
            <p class="batch"
               @click="handleDelete()">删除</p>
          </div>
        </div>
        <div class="block">
          <el-pagination background
                         layout="total, prev, pager, next, sizes, jumper"
                         :current-page="Number(query.pageIndex)"
                         :page-sizes="[10, 20, 50, 100, 500]"
                         :page-size="Number(query.pageSize)"
                         :total="Number(pageTotal)"
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"></el-pagination>

        </div>
      </div>

    </el-card>
    <FeedbackDetail :visible="feedbackDetailVisible"
                    :id="detail.id"
                    @close="handleCLose" />
  </div>
</template>

<script>
import { feedbackList, feedbackDelte } from '@/api/senior'
import FeedbackDetail from '@/components/dialog/feedbackDetail/index'

export default {
  components: { FeedbackDetail },
  data() {
    return {
      results: [],
      createDialog: false,
      query: {
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1,
      },
      progress_Status: 0,
      progressStatus: [
        {
          label: '全部',
          value: '',
        },
        {
          label: '待处理',
          value: 0,
        },
      ],
      qustionType: [
        {
          label: '问题反馈',
          value: 1,
        },
        {
          label: '功能建议',
          value: 2,
        },
      ],
      pageTotal: 0,
      chooseList: [],
      detail: {},
      feedbackDetailVisible: false,
    }
  },
  created() {
    this.getList()
  },
  watch: {},
  computed: {},
  methods: {
    handleCLose() {
      // console.log("yijing")
      this.feedbackDetailVisible = false
      this.getList()
    },
    close() {
      this.relevanceVisible = false
    },
    lookDetailClose() {},
    handleCreate() {
      this.$router.push(`/senior/topicCreate`)
    },
    handleSizeChange(val) {
      this.query.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.query.pageIndex = val
      this.getList()
    },
    getList(isReset = false) {
      console.log('999')
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }
      this.$set(this.query, 'handle_progress_statuses', this.progress_Status)
      const params = Object.assign({}, this.query)
      feedbackList(params).then((res) => {
        this.results = res.list
        console.log('result', this.results)
        this.pageTotal = res.count
      })
    },
    handleSelectionChange(val) {
      this.chooseList = val
    },
    formateType(val) {
      let types = {
        1: '辅导推荐',
        2: '资料制作',
        3: '讲座答疑',
        4: '课程分销',
        5: '其他综合',
      }
      return types[val]
    },

    handleDelete() {
      if (this.chooseList.length == 0) {
        this.$message.error('还没有选择要删除的数据')
        return
      }
      this.$confirm('确定要删除这些信息吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let ids = this.chooseList.map((v) => {
          return v.id
        })

        feedbackDelte({ ids }).then((res) => {
          this.$message.success('删除成功')
          this.getList()
        })
      })
    },
    handleToDetail(row) {
      this.detail = row
      this.feedbackDetailVisible = true
      // this.$router.push(`/senior/task/${id}`)
    },
  },
}
</script>

<style lang="less" scoped>
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }

  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .imgBox {
    display: flex;
    flex-flow: wrap;
    .questionImg {
      margin-right: 4px;
      width: 35px;
      height: 35px;
    }
  }

  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;

      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
    }
  }
}
.el-link {
  font-size: 12px;
  margin: 0px 5px;
}
.el-tag {
  margin: 0px 5px;
}
.tag-wrap {
  text-align: left;
}
.card-header {
  margin-bottom: 16px;
}
.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .left {
    display: flex;
    align-items: center;
    .xian {
      margin-left: 16px;
      margin-right: 16px;
      width: 1px;
      height: 20px;
      background: #dcdfe6;
      border-radius: 0px 0px 0px 0px;
    }
    .batch {
      text-align: center;
      font-weight: 400;
      font-size: 13px;
      color: #f56c6c;
      width: 46px;
      height: 26px;
      line-height: 26px;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #f56c6c;
    }
  }
}
.link-wrap {
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.left {
  width: 100%;
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.badge-content {
  position: relative;
  .badge {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: #f56c6c;
    color: #fff;
    font-size: 11px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: -5px;
    top: -2px;
  }
}
</style>
